import * as Yup from 'yup';
import { v4 as uuidV4 } from 'uuid';
import { ICommodity } from '../commodity/commodity';
import { IOptionType } from '@zz2/zz2-ui';
import OptionType from '../../optionType';
import { ISeason } from './season';
import { ISeasonFormValues } from './seasonFormValues';
import { ISeasonUpsert } from './seasonUpsert';
import moment from 'moment';

export default class SeasonModelHelper {
    public static createFormValues = (
        season : ISeason | null,
        commodities : Array<ICommodity>,
        defaultCommodity : ICommodity | null
    ) : ISeasonFormValues => {
        if (!season) return {
            id: 0,
            guid: uuidV4(),
            code: '',
            name: '',
            commodity: defaultCommodity
                ? OptionType.fromDataModel(defaultCommodity)
                : null,
            startDate: moment.utc().local(),
            endDate: null,
            isActive: true,
        };

        const commodity = commodities.find(x => x.id === season.commodityId);

        return {
            id: season.id,
            guid: season.guid,
            code: season.code,
            name: season.name ?? '',
            commodity:  commodity
                ? OptionType.fromDataModel(commodity)
                : null,
            startDate: moment.utc(season.startDate).local(),
            endDate: season.endDate ? moment.utc(season.endDate).local() : null,
            isActive: season.isActive,
        };
    };

    public static createUpsert = (formValues : ISeasonFormValues) : ISeasonUpsert => {
        return {
            id: formValues.id,
            guid: formValues.guid,
            code: formValues.code,
            name: formValues.name,
            commodityId: Number(formValues.commodity?.value ?? 0),
            startDate: formValues.startDate,
            endDate: formValues.endDate,
            isActive: formValues.isActive,
        };
    };

    public static formSchema = () : Yup.ObjectSchema<ISeasonFormValues> => Yup.object().shape({
        id: Yup.number().typeError('Please enter a number.').required('Required'),
        guid: Yup.string().required('Required'),
        code: Yup.string().trim().min(1, 'Must have at least 1 character').required('Required'),
        name: Yup.string().trim().min(1, 'Must have at least 1 character').required('Required'),
        commodity: Yup.mixed<IOptionType>().defined().required('Required'),
        startDate: Yup.mixed<moment.Moment>().defined().required('Required'),
        endDate: Yup.mixed<moment.Moment>().defined().nullable()
            .when(['startDate'], ([startDate]) => {
                return Yup.date()
                    .nullable()
                    .min(moment(startDate).startOf('day'), 'End date cannot be before start date.');
            }),
        isActive: Yup.boolean().required('Required'),
    });
}
